import React from 'react';
import { Typography } from "../../ecosystem/";

export const InHomeQuestionsHeading = ({
    className,
    heading,
    subheading
}) => {

    return (<>
        <div className={`row in-home-questions-heading-container ${className ? className : ''}`}>
            <div className="col-12">
                <Typography
                    tag="h2"
                    type={"heading-03"}
                >
                    {heading}
                </Typography>
            </div>
            {subheading && 
                <div className="col-12 in-home-questions-subheading">
                    <Typography
                        type={"body-02"}
                    >
                        {subheading}
                    </Typography>
                </div>
            }
        </div> 
    </>);
}

